import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import headandfoot from '../components/computer/headandfoot'
import creditsearch from '../components/computer/creditsearch'
import authenticationsearch from '../components/computer/authenticationsearch'
// eslint-disable-next-line no-unused-vars
import adminleftlist from '../components/admin/adminleftlist'
// eslint-disable-next-line no-unused-vars
import adminindex from '../components/admin/adminindex'
import authenticationadd from '../components/admin/authenticationadd'
import authenticationlist from '../components/admin/authenticationlist'
import authenticationupdate from '../components/admin/authenticationupdate'
import creditadd from '../components/admin/creditadd'
import creditlist from '../components/admin/creditlist'
import creditupdate from '../components/admin/creditupdate'
import evaluation from '../components/computer/evaluation'
import query from '../components/computer/query'
import signin from '../components/computer/signin'
import adminmanage from '../components/admin/adminmanage'
import adminmanageadd from '../components/admin/adminmanageadd'
import adminmanageupdate from '../components/admin/adminmanageupdate'
import creditdetails from '../components/computer/creditdetails'
import enterpriselogin from '../components/computer/enterpriselogin'
import mechanismlogin from '../components/computer/mechanismlogin'
import enterprisereg from '../components/computer/enterprisereg'
import enterpriselist from '../components/enterprise/enterpriselist'
import modifymessage from '../components/enterprise/modifymessage'
import enterevaluation from '../components/enterprise/enterevaluation'
import enterquery from '../components/enterprise/enterquery'
import disclosureshome from '../components/disclosures/disclosureshome'
import disclosuresRelease from '../components/disclosures/disclosuresRelease'
import admininformation from '../components/admin/admininformation'
import admininformationadd from '../components/admin/admininformationadd'
import admininformationupdate from '../components/admin/admininformationupdate'
import admincreditlist from '../components/admin/admincreditlist'
import adminevaluatelist from '../components/admin/adminevaluatelist'
import adminJournallist from '../components/admin/adminJournallist'
import adminuserlist from '../components/admin/adminuserlist'
import adminuserupdate from '../components/admin/adminuserupdate'
import adminentlist from '../components/admin/adminentlist'
import adminjglist from '../components/admin/adminjglist'
import adminuseradd from '../components/admin/adminuseradd'
import enterquerylist from '../components/enterprise/enterquerylist'
import enterquerylists from '../components/enterprise/enterquerylists'
import disclosureslist from '../components/disclosures/disclosureslist'
import admincreditlistbtn from '../components/admin/admincreditlistbtn'
import admininformationpreview from '../components/admin/admininformationpreview'
import enterpriseindex from '../components/enterprise/enterpriseindex'
import disclosureindex from '../components/disclosures/disclosureindex'
import sxcj from '../components/computer/sxcj'
import xydt from '../components/computer/xydt'
import news from '../components/computer/news'
import zcwj from '../components/computer/zcwj'
import cxlm from '../components/computer/cxlm'
import lmbj from '../components/computer/lmbj'
import lmzc from '../components/computer/lmzc'
import jdfw from '../components/computer/jdfw'
import homeNoHead from '../components/homeNoHead'
import homeNoHeadFoot from '../components/homeNoHeadFoot'
import new2024101701 from '../view/news/new2024101701'
import news2024101702 from '../view/news/news2024101702'
import news2024101703 from '../view/news/news2024101703'
import news2025052201 from '../view/news/news2025052201'
import newslist from '../view/news/list'
import searchCredit from '../view/search/index'
import searchCreditH5 from '../view/search/mobile'
import searchCreditH5Details from '../view/search/mobileDetails'
import HomePhone from '../components/HomePhone'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {path: '/',
      name: 'headandfoot',
      component: headandfoot,
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: '/HomePhone',
          name: 'HomePhone',
          component: HomePhone
        },
        {
          path: '/searchCredit',
          name: 'searchCredit',
          component: searchCredit
        },
        {
          path: '/searchCreditH5',
          name: 'searchCreditH5',
          component: searchCreditH5
        },
        {
          path: '/searchCreditH5Details',
          name: 'searchCreditH5Details',
          component: searchCreditH5Details
        },
        {
          path: '/newslist',
          name: 'newslist',
          component: newslist
        },
        {
          path: '/new20241017011',
          name: 'new20241017011',
          component: new2024101701
        },
        {
          path: '/news2024101702',
          name: 'news2024101702',
          component: news2024101702
        },
        {
          path: '/news20241017031',
          name: 'news20241017031',
          component: news2024101703
        },
        {
          path: '/news2025052201',
          name: 'news2025052201',
          component: news2025052201
        },
        {
          path: '/sxcj',
          name: 'sxcj',
          component: sxcj
        },
        {
          path: '/xydt',
          name: 'xydt',
          component: xydt
        },
        {
          path: '/zcwj',
          name: 'zcwj',
          component: zcwj
        },
        {
          path: '/news',
          name: 'news',
          component: news
        },
        {
          path: '/cxlm',
          name: 'cxlm',
          component: cxlm
        },
        {
          path: '/lmbj',
          name: 'lmbj',
          component: lmbj
        },
        {
          path: '/lmzc',
          name: 'lmzc',
          component: lmzc
        },
        {
          path: '/jdfw',
          name: 'jdfw',
          component: jdfw
        },
        {
          path: '/creditsearch',
          name: 'creditsearch',
          component: creditsearch
        },
        {
          path: '/admininformationpreview',
          name: 'admininformationpreview',
          component: admininformationpreview
        },
        {
          path: '/creditdetails',
          name: 'creditdetails',
          component: creditdetails
        },
        {
          path: '/evaluation',
          name: 'evaluation',
          component: evaluation
        },
        {
          path: '/enterpriselogin',
          name: 'enterpriselogin',
          component: enterpriselogin
        },
        {
          path: '/mechanismlogin',
          name: 'mechanismlogin',
          component: mechanismlogin
        },
        {
          path: '/enterprisereg',
          name: 'enterprisereg',
          component: enterprisereg
        },
        {
          path: '/authenticationsearch',
          name: 'authenticationsearch',
          component: authenticationsearch
        },

        {
          path: '/query',
          name: 'query',
          component: query
        }
      ]},
    {
      path: '/signin',
      name: 'signin',
      component: signin
    },
    {
      path: '/adminleftlist',
      name: 'adminleftlist',
      // component: adminleftlist,
      children: [
        // {
        //   path: '/adminleftlist',
        //   name: 'adminindex',
        //   component: adminindex
        // },
        {
          path: '/authenticationadd',
          name: 'authenticationadd',
          component: authenticationadd
        },
        {
          path: '/adminmanage',
          name: 'adminmanage',
          component: adminmanage
        },
        {
          path: '/adminmanageadd',
          name: 'adminmanageadd',
          component: adminmanageadd
        },
        {
          path: '/admininformation',
          name: 'admininformation',
          component: admininformation
        },

        {
          path: '/admininformationadd',
          name: 'admininformationadd',
          component: admininformationadd
        },
        {
          path: '/admininformationupdate',
          name: 'admininformationupdate',
          component: admininformationupdate
        },
        {
          path: '/adminuserlist',
          name: 'adminuserlist',
          component: adminuserlist
        },
        {
          path: '/adminuseradd',
          name: 'adminuseradd',
          component: adminuseradd
        },
        {
          path: '/adminuserupdate',
          name: 'adminuserupdate',
          component: adminuserupdate
        },
        {
          path: '/admincreditlist',
          name: 'admincreditlist',
          component: admincreditlist
        },
        {
          path: '/admincreditlistbtn',
          name: 'admincreditlistbtn',
          component: admincreditlistbtn
        },
        {
          path: '/adminentlist',
          name: 'adminentlist',
          component: adminentlist
        },
        {
          path: '/adminjglist',
          name: 'adminjglist',
          component: adminjglist
        },
        {
          path: '/adminevaluatelist',
          name: 'adminevaluatelist',
          component: adminevaluatelist
        },
        {
          path: '/adminJournallist',
          name: 'adminJournallist',
          component: adminJournallist
        },
        {
          path: '/adminmanageupdate',
          name: 'adminmanageupdate',
          component: adminmanageupdate
        },
        {
          path: '/authenticationlist',
          name: 'authenticationlist',
          component: authenticationlist
        },
        {
          path: '/authenticationupdate',
          name: 'authenticationupdate',
          component: authenticationupdate
        },
        {
          path: '/creditadd',
          name: 'creditadd',
          component: creditadd
        },
        {
          path: '/creditlist',
          name: 'creditlist',
          component: creditlist
        }, {
          path: '/creditupdate',
          name: 'creditupdate',
          component: creditupdate
        }
      ]},
    {path: '/enterpriselist',
      name: 'enterpriselist',
      component: enterpriselist,
      children: [{
        path: '/enterpriselist',
        name: 'enterpriseindex',
        component: enterpriseindex
      },
      {
        path: '/modifymessage',
        name: 'modifymessage',
        component: modifymessage
      },
      {
        path: '/enterevaluation',
        name: 'enterevaluation',
        component: enterevaluation
      },
      {
        path: '/enterquery',
        name: 'enterquery',
        component: enterquery
      },
      {
        path: '/enterquerylist',
        name: 'enterquerylist',
        component: enterquerylist
      },
      {
        path: '/enterquerylists',
        name: 'enterquerylists',
        component: enterquerylists
      }
      ]},
    {path: '/disclosureshome',
      name: 'disclosureshome',
      component: disclosureshome,
      children: [{
        path: '/disclosureshome',
        name: 'disclosureindex',
        component: disclosureindex
      },
      {
        path: '/disclosuresRelease',
        name: 'disclosuresRelease',
        component: disclosuresRelease
      },
      {
        path: '/disclosureslist',
        name: 'disclosureslist',
        component: disclosureslist
      }
      ]},
    {path: '/homeNoHeadFoot',
      name: 'homeNoHeadFoot',
      component: homeNoHeadFoot,
      children: [ {
        path: '/homeNoHead',
        name: 'homeNoHead',
        component: homeNoHead
      }
      ]}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js